import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography,
  Icon,
  Button,
} from '@material-ui/core';
import { reduxForm, Field } from 'redux-form';
import { LoadingIndicator } from '../../component';
import LocalizedString from '../../localization';
import {
  DEFAULT_STYLES,
  COLOR_PRIMARY,
  RXFORM_ERP_PAYMENT_LOG_FILTER_DIALOG,
  RXFIELD_ERP_PAYMENT_LOG_DETAIL_PROFORMA_NO,
  RXFIELD_ERP_PAYMENT_LOG_DETAIL_STATUS,
  ERP_PAYMENT_LOG_STATUS_OPTION,
} from '../../constant';
import {
  renderReduxFormFilterableSelectField, renderReduxFormTextField,
} from '../../helper';

const styles = () => ({
  btnPrimary: {
    ...DEFAULT_STYLES.WEB_USER.BUTTON_PRIMARY,
  },
  dialogActions: {
    margin: '0 -24px',
    marginTop: '24px',
    padding: 24,
    borderTop: '1px solid #C4C4C4',
    justifyContent: 'space-between',
    paddingBottom: 0,
    display: 'flex',
  },
  fontWeightBold: {
    fontWeight: 'bold',
  },
  reject: {
    color: COLOR_PRIMARY,
  },
});

const ErpPaymentLogFilterDialog = ({
  classes,
  open,
  loading,
  onStatusSelected,
  handleSubmit,
  onSubmitPressed,
  onClose,
  onResetPressed,
}) => (
  <>
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      onEnter={() => {}}
    >
      <DialogTitle>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
          }}
        >
          <Typography color="primary" variant="h6">
            {LocalizedString.response.labelFilter}
          </Typography>
          <IconButton onClick={onClose}>
            <Icon>close</Icon>
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={handleSubmit(values => onSubmitPressed(values))}>
          <Field
            name={RXFIELD_ERP_PAYMENT_LOG_DETAIL_PROFORMA_NO}
            component={renderReduxFormTextField}
            label={LocalizedString.erpPaymentLog.labelProformaNo}
          />
          <Field
            name={RXFIELD_ERP_PAYMENT_LOG_DETAIL_STATUS}
            component={renderReduxFormFilterableSelectField}
            options={ERP_PAYMENT_LOG_STATUS_OPTION}
            label={LocalizedString.response.labelStatus}
            onValueChange={onStatusSelected}
          />
          <div className={classes.dialogActions}>
            <div style={{ flexGrow: 1 }} />
            <div>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.btnPrimary}
                disabled={loading}
              >
                Apply
              </Button>
              <Button variant="text" className={classes.reject} onClick={onResetPressed}>
                {LocalizedString.erpPaymentLog.labelReset}
              </Button>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
    {loading && <LoadingIndicator />}
  </>
);
ErpPaymentLogFilterDialog.propTypes = {
  classes: PropTypes.shape(PropTypes.any).isRequired,
  open: PropTypes.bool.isRequired,

  handleSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitPressed: PropTypes.func.isRequired,
  onStatusSelected: PropTypes.func.isRequired,
};

export default reduxForm({
  form: RXFORM_ERP_PAYMENT_LOG_FILTER_DIALOG,
  enableReinitialize: true,
})(withStyles(styles)(ErpPaymentLogFilterDialog));
